import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNaviconChevron = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.24923 15.763C5.61673 16.1305 6.20923 16.1305 6.57673 15.763L12.8092 9.53047C13.1017 9.23797 13.1017 8.76547 12.8092 8.47297L6.57673 2.24047C6.20923 1.87297 5.61673 1.87297 5.24923 2.24047C4.88173 2.60797 4.88173 3.20047 5.24923 3.56797L10.6792 9.00547L5.24173 14.443C4.88173 14.803 4.88173 15.403 5.24923 15.763Z",
		fill: "#6B719D"
	})
});
export default SvgNaviconChevron;
